import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Logo & Description */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/14febd11ed764a2e4131edc63c3ba26f/0a3ef7c86ce9fe9f73294dec3a9e17ad.png"
              alt="GOODFIX"
              className="h-9 w-auto mb-4"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-xs">
              {t('footer.description')}
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-sky-500/15 shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-sky-400 text-sm"></i>
                </div>
                <p className="text-slate-300 text-sm">{t('footer.address')}</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-sky-500/15 shrink-0 mt-0.5">
                  <i className="ri-time-line text-sky-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-slate-300 text-sm">{t('footer.workingHours')}</p>
                  <p className="text-slate-400 text-sm">{t('footer.workingSaturday')}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">{t('footer.servicesTitle')}</h3>
            <ul className="space-y-2.5">
              {['service1','service2','service8','service6','service9'].map((key) => (
                <li key={key}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-slate-400 hover:text-sky-400 text-sm transition-colors duration-200 cursor-pointer text-left"
                  >
                    {t(`services.${key}`)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacts */}
          <div>
            <h3 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">{t('footer.contactsTitle')}</h3>
            <div className="space-y-3 mb-6">
              <a
                href="tel:+380957403000"
                className="flex items-center gap-3 group"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-sky-500/15 shrink-0">
                  <i className="ri-phone-line text-sky-400 text-sm group-hover:scale-110 transition-transform duration-200"></i>
                </div>
                <span className="text-slate-300 hover:text-sky-400 font-medium text-sm transition-colors duration-200">095 740 30 00</span>
              </a>
              <a
                href="tel:+380937403000"
                className="flex items-center gap-3 group"
              >
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-sky-500/15 shrink-0">
                  <i className="ri-phone-line text-sky-400 text-sm group-hover:scale-110 transition-transform duration-200"></i>
                </div>
                <span className="text-slate-300 hover:text-sky-400 font-medium text-sm transition-colors duration-200">093 740 30 00</span>
              </a>
            </div>
            <a
              href="tel:+380957403000"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r from-sky-500 to-cyan-500 text-white text-sm font-semibold shadow-md shadow-sky-900/30 hover:scale-105 transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              {t('cta.callNow')}
            </a>

            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://t.me/goodfix_service"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Telegram"
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#229ED9]/15 border border-[#229ED9]/30 text-[#229ED9] hover:bg-[#229ED9]/30 hover:scale-110 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-telegram-line text-base"></i>
              </a>
              <a
                href="https://www.instagram.com/goodfix.com.ua/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 flex items-center justify-center rounded-xl bg-pink-500/15 border border-pink-400/30 text-pink-400 hover:bg-pink-500/30 hover:scale-110 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">{t('footer.copyright')}</p>
          <div className="flex items-center gap-5">
            {['home','services','advantages','contacts'].map((id) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                className="text-slate-500 hover:text-sky-400 text-xs transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {t(`nav.${id}`)}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
